
import { Vue, Component } from 'vue-property-decorator';

/**
 * Component that represent general page view
 */
@Component
export default class AppView extends Vue {}
